const types = {
  SET_CURRENT_JOB_BOARD: 'SET_CURRENT_JOB_BOARD',
  SET_CURRENT_JOB: 'SET_CURRENT_JOB',
  SET_JOB_TO_CLONE: 'SET_JOB_TO_CLONE',
};
const state = {
  currentJobBoard: null,
  currentJob: null,
  jobToClone: null
};

const mutations = {
  [types.SET_CURRENT_JOB_BOARD]: (state, value) => {
    state.currentJobBoard = value;
  },
  [types.SET_CURRENT_JOB]: (state, value) => {
    state.currentJob = value;
  },
  [types.SET_JOB_TO_CLONE]: (state, value) => {
    state.jobToClone = value;
  },
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
